import { Box, Typography, Card, CardContent } from '@mui/material';

import RunCardHeader from './RunCardHeader';
import RunCardContent from './RunCardContent';
import useRunCard from './useRunCard';

export default function RunCard({ run, showLogs = false }) {
  const {
    datesMatch,
    elapsedTime,
    finishedDate,
    finishedTime,
    handleNavigateToEvents,
    handleRerun,
    isFetchingLogs,
    isRerunning,
    logs,
    logsError,
    logsExpanded,
    parsedFeatures,
    screenshotError,
    screenshotExpanded,
    screenshotUrl,
    setLogsExpanded,
    setScreenshotExpanded,
    startedDate,
    startedTime,
    statusColor,
  } = useRunCard({ run, showLogs });

  return (
    <Card
      sx={{
        mb: 2,
        border: run.status === 'running' ? '2px solid' : '1px solid',
        borderColor: run.status === 'running' ? 'warning.main' : 'divider',
      }}
    >
      <CardContent>
        <RunCardHeader
          run={run}
          statusColor={statusColor}
          isRerunning={isRerunning}
          onRerun={handleRerun}
          onNavigateToEvents={handleNavigateToEvents}
          datesMatch={datesMatch}
          startedDate={startedDate}
          finishedDate={finishedDate}
          startedTime={startedTime}
          finishedTime={finishedTime}
          elapsedTime={elapsedTime}
        />

        <RunCardContent
          run={run}
          showLogs={showLogs}
          logsExpanded={logsExpanded}
          setLogsExpanded={setLogsExpanded}
          logs={logs}
          isFetchingLogs={isFetchingLogs}
          logsError={logsError}
          parsedFeatures={parsedFeatures}
          screenshotExpanded={screenshotExpanded}
          setScreenshotExpanded={setScreenshotExpanded}
          screenshotUrl={screenshotUrl}
          screenshotError={screenshotError}
        />

        {/* Command */}
        <Box mt={2}>
          <Typography variant="caption" color="text.secondary">
            Command: <code style={{ fontSize: '0.75rem' }}>{run.command || 'N/A'}</code>
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
}
